import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import store from "./store";
import "element-ui/lib/theme-chalk/index.css";
import custom from "./util/custom";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import "./assets/css/reset.css";
import "./assets/css/el.css";
import "./assets/css/public.css";
import "lib-flexible";
// import "leaflet/dist/leaflet.css";
import axios from "axios";
import JSEncrypt from "jsencrypt";
Vue.prototype.$jsEncrypt = JSEncrypt;

Vue.prototype.$axios = axios;
Object.keys(custom).forEach(key => {
  Vue.prototype["$" + key] = custom[key];
});

import FileSaver from 'file-saver'
// import XLSX from 'xlsx'
import * as XLSX from 'xlsx'
Vue.prototype.$FileSaver = FileSaver; //设置全局
Vue.prototype.$XLSX = XLSX; //设置全局

const requireComponent = require.context(
  // 其组件目录的相对路径
  "./components",
  // 是否查询其子目录
  false,
  // 匹配基础组件文件名的正则表达式
  /\.vue$/
);
requireComponent.keys().forEach(fileName => {
  // 获取组件配置
  const componentConfig = requireComponent(fileName);

  // 获取组件的 PascalCase 命名
  const componentName = upperFirst(
    camelCase(
      // 获取和目录深度无关的文件名
      fileName
      .split("/")
      .pop()
      .replace(/\.\w+$/, "")
    )
  );
  Vue.component(componentName, componentConfig.default || componentConfig);
});
Vue.config.productionTip = false;
Vue.use(ElementUI);
/* eslint-disable no-new */
const vue = new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>"
});
export default vue



// WEBPACK FOOTER //
// ./src/main.js